"use client"
import Button from "@/components/ui/Button"
import { sendResetPasswordEmail } from "@/services/api/useApi"
import { FormEvent, useState } from "react"
import { toast } from "sonner"

function EnterEmail() {
   //  const url = new URL(window.location.href)
   //  const resetToken = url.searchParams.get("reset_token")
   const [success, setSuccess] = useState(false)
   const [message, setMessage] = useState("")

   const [email, setEmail] = useState("")

   const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      try {
         // await raAuthInstance.sendResetPasswordEmail(email);
         await sendResetPasswordEmail(email)

         toast.success("Password reset email sent successfully.")
         setMessage("Check your email for a password reset link.")
         setSuccess(true)

         // alert();
      } catch (error) {
         console.error("Password reset email failed:", error)
         toast.error("Password reset email failed. Please try again.")
         setMessage("Password reset email failed. Please try again.")
         setSuccess(false)
      }
   }

   return (
      <form
         onSubmit={handleSubmit}
         className="col-span-full mx-auto  grid   max-w-96 grid-cols-1  place-content-center items-center justify-center  gap-y-4 sm:grid-cols-6"
      >
         {/* <input type="hidden" name="reset_token" value={resetToken ?? ""} /> */}

         <div className=" col-span-full   space-y-2 text-center">
            <label htmlFor="email" className="col-span-full block">
               <h1 className="text-custom-sm-normal font-medium leading-6 ">Enter Email Address</h1>
            </label>
            <div className="">
               <input
                  type="email"
                  name="email"
                  value={email}
                  id="email"
                  onChange={(e) => setEmail(e.target.value)}
                  className={`${false ? "ring-red-500 " : "ring-gray-00"} col-span-full block w-full rounded-md border-0 bg-white px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 invalid:border-red-500 focus:ring-2 focus:ring-inset focus:ring-brandOrange sm:text-sm sm:leading-6`}
               />
               {/* {errors.firstName && (
              <p className="text-xs text-red-500">{errors.firstName.message}</p>
            )} */}
            </div>
         </div>
         {/* <button type="submit"></button> */}
         <Button type="submit" className="col-span-full   text-center">
            Send Password Reset Email
         </Button>

         <div className="col-span-full text-center">
            <p className={`text-sm ${success ? "text-green-500" : "text-red-500"}`}>{message}</p>
         </div>
      </form>
   )
}

export default EnterEmail
